import {Component, Input, OnInit} from '@angular/core';
import Helper from "../../util/helper";

@Component({
  selector: 'app-avatar-placeholder',
  templateUrl: './avatar-placeholder.component.html',
  styleUrls: ['./avatar-placeholder.component.scss']
})
export class AvatarPlaceholderComponent implements OnInit {
  @Input() name;
  @Input() size = '2rem';

  constructor() { }

  ngOnInit(): void {
  }

  getInitials(name: string) {
    return Helper.getInitials(name);
  }

  getInitialsBg(name: string) {
    return Helper.randomColorByName(name);
  }

}
